


































































import { Component, Inject, Vue } from 'vue-property-decorator'
import { RealworksCredentials } from '@/api/model/credentials'
import { CredentialsType } from '@/api/types'
import { v4 as uuid } from 'uuid'
import { RealworksCredentialsAPI } from '@/api/backend-client'

@Component
export default class CompanySettingsRealworksCredentialsList extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>

    get realworksCredentials(): RealworksCredentials[] {
        return this.$currentCompany.getCredentialsWithType(CredentialsType.REALWORKS) as RealworksCredentials[]
    }

    get sortedRealworksCredentials(): RealworksCredentials[] {
        return [...this.realworksCredentials].sort((a, b) => a.description.localeCompare(b.description))
    }

    async goToRealworksCredentialsEdit(credentials: RealworksCredentials): Promise<void> {
        await this.$router.push({
            name: 'company_settings_realworks_credentials_edit',
            params: {
                credentialsId: credentials.id,
            },
        })
    }

    async goToRealworksCredentialsCreate(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_realworks_credentials_create',
            params: {
                credentialsId: uuid(),
            },
        })
    }

    async deleteRealworksCredentials(credentials) {
        if (confirm(this.$t('company_settings.realworks_credentials.delete_confirm').toString())) {
            await RealworksCredentialsAPI.delete(credentials.id)
            await this.reloadCompany()
        }
    }

    get canCreateRealworksCredentials(): boolean {
        if (this.$currentCompany.licenseType !== 'branch-license' && !this.$currentCompany.modules.includes('virtual-colleague')) {
            return false
        }

        const counts = {
            agenda : 0,
            objecten : 0,
            facturen : 0,
            relaties : 0,
            taken: 0,
        }

        this.realworksCredentials.forEach(item => {
            counts.agenda += item.canRequestAgenda ? 1 : 0
            counts.objecten += item.canRequestObjecten ? 1 : 0
            counts.facturen += item.canRequestFacturen ? 1 : 0
            counts.relaties += item.canRequestRelaties ? 1 : 0
            counts.taken += item.canRequestTaken ? 1 : 0
        })

        for (const count in Object.values(counts)) {
            if (Number.parseInt(count, 10) < this.$currentCompany.amountOfBranches) {
                return true
            }
        }

        return false
    }
}
